module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'fields',
        'autoComplete',
    ],

    config: {
        showArrowInline: true,
        arrowIcons: {
            closed: 'fi fi-angle-down',
            opened: 'fi fi-angle-up',
        },
        nullAbleIcon: 'fi fi-times',
    },

    methods: {
        sanitizeOptionAppearance(refOption){
            refOption = refOption || {}
            const fieldConfig = this.model.config || {}
            const appearanceType = fieldConfig.appearanceType
            const attributes = (refOption.resource || {}).attributes
            const nameParts = []
            let symbol = ''
            refOption.additionalClasses = []

            if(appearanceType === 'driver'){
                symbol = 'fi fi-drivers'
                if(symbol){
                    nameParts.push(`<i class="${symbol}"></i>`)
                }
                if(refOption.realName){
                    nameParts.push(String(refOption.realName).trim())
                }

                if (!attributes.active){
                    refOption.additionalClasses.push(`hiddenIfNotSelected`)
                    refOption.additionalClasses.push(`showOnConditionViolation`)
                    nameParts.push(` (${storage.__('drivers.picker.inactive')})`)
                }

                refOption.realName = nameParts.join('')
            }
        }
    }
}